module.exports = __webpack_public_path__ + "static/media/longines_automatic.6cbff582.jpg";